<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-10 10:53:27
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-04-10 13:56:18
 * @FilePath: \hzs-nutra-wecom-shop\src\views\BuyerProxyPayment\createCustomerSuc.vue
 * @Description: 代客下单 - 创建客户 成功
-->

<template>
  <div class="page-container">
    <div class="mainContent h100">
      <div class="customerItem pct100 rel">
        <div class="up flex align-center">
          <img :src="userInfo?.avatar_url || EmptyHeadImg" class="img" alt="" />

          <div class="msg">
            <div class="name">{{ userInfo?.user_base_info?.name }}</div>
            <div class="gOrA">
              {{ getGender(userInfo?.user_base_info?.sex) }}
              {{ getAge(userInfo?.user_base_info?.birthday) }}岁
            </div>
          </div>
        </div>

        <div class="down">
          <div class="phone">
            手机号码：{{ userInfo?.user_base_info?.phone }}
          </div>
          <div class="phone">
            归属门店：{{ userInfo?.user_shop_info?.name }}
          </div>
        </div>

        <img
          src="@/assets/img/icons/selected.png"
          alt=""
          class="abs selectedImg"
        />
      </div>

      <div class="successTip flex flex-col align-center">
        <img src="@/assets/img/customer/success.png" alt="" />
        <span class="tips">客户档案创建成功！</span>
      </div>
    </div>

    <!-- 底部保存按钮 -->
    <div class="bottom_button_box">
      <van-button
        round
        block
        type="primary"
        color="#DCBB89"
        class="save-btn"
        @click="handleTakeOrder"
      >
        {{ returnBack ? "返回" : "去下单" }}
      </van-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from "dayjs";
import { useRouter, useRoute } from "vue-router";
import CustomerApi from "@/utils/api/customer";

const router = useRouter();
const route = useRoute();
const { returnBack, returnBackQuery, user_uuid } = route.query;

const userInfo = ref({});

const handleTakeOrder = () => {
  let path = "";
  if (returnBack) {
    path = returnBack as string;
  } else {
    path = "/takeOrderType";
  }
  let query = { user_uuid, ...JSON.parse((returnBackQuery as string) || "{}") };
  router.push({
    path,
    query,
  });
};

onMounted(async () => {
  let res = await CustomerApi._customerInfo({ user_uuid }).catch((err) => {});

  if (res?.code === 200) {
    userInfo.value = res?.data || {};
  }
});

const getGender = (gender: number | string) =>
  ({
    1: "男",
    2: "女",
    3: "",
  })[gender] || "";
function getAge(birthday) {
  return dayjs().diff(dayjs(birthday), "year");
}
</script>

<style lang="scss">
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/

.tips {
  height: 22px;
  font-family:
    PingFang SC,
    PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.successTip {
  margin-top: 100px;
}

.customerItem {
  padding: 6px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  &:not(:last-child) {
    margin-bottom: 10px;
  }

  .up {
    padding: 11px 10px;
    border-bottom: 1px solid #f2f2f2;

    .img {
      width: 42px;
      height: 42px;
      border-radius: 100%;

      margin-right: 11px;
    }

    .name {
      height: 25px;
      line-height: 25px;
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .gOrA {
      height: 20px;
      line-height: 20px;
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
  .down {
    padding: 12px 10px 6px;

    font-family:
      PingFang SC,
      PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;

    div {
      height: 20px;
      line-height: 20px;
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
  .selectedImg {
    width: 16px;
    height: 16px;
    top: 16px;
    right: 16px;
  }
}
</style>
